import { render, staticRenderFns } from "./CheckboxGroupView.vue?vue&type=template&id=295055f7&scoped=true&"
import script from "./CheckboxGroupView.vue?vue&type=script&lang=js&"
export * from "./CheckboxGroupView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "295055f7",
  null
  
)

export default component.exports